import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';
import TypographyLink from '@ui/TypographyLink';
import palette from '@ui/palette';
import Icon from '@ui/Icon';

export const LEGACY_STUDIO_RETIREMENT_HELP_HREF =
  'https://help.wellsaid.io/hc/en-us/articles/51751205121299-Migrating-Your-Legacy-Projects-to-WellSaid-Studio';

const useStyles = makeStyles({ name: 'LegacyStudioRetirementNotice' })(
  theme => ({
    root: {
      borderLeft: `2px solid #FFA777`,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: theme.spacing(0.5),
      borderBottomRightRadius: theme.spacing(0.5),
      padding: theme.spacing(2, 2),
      backgroundColor: `#3C291E`,
      display: 'flex',
      gap: theme.spacing(1.25),
      alignItems: 'flex-start',
    },
    iconWrap: {
      flexShrink: 0,
      marginTop: 2,
      backgroundColor: palette.papaya_500,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: `4px`,
      borderRadius: `20px`,
      // infoCircle.svg bakes in stroke="#C7C7C7"; htmlColor won’t apply — override here
      // note this is a hacky workaround and we should invalidate info-circle and/or replace all refs
      '& svg path': {
        stroke: palette.gray_0,
      },
    },
    title: {
      marginBottom: theme.spacing(0.5),
    },
    learnMoreLink: {
      '&:hover': {
        color: palette.papaya_200,
      },
    },
  })
);

interface LegacyStudioRetirementNoticeProps {
  learnMoreHref?: string;
}

const LegacyStudioRetirementNotice = ({
  learnMoreHref = LEGACY_STUDIO_RETIREMENT_HELP_HREF,
}: LegacyStudioRetirementNoticeProps) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root} role="note">
      <Box className={classes.iconWrap}>
        <Icon
          type="infoCircle"
          style={{
            fontSize: '24px',
            marginBottom: `-8px`,
            marginRight: `-8px`,
          }}
        />
      </Box>
      <Box>
        <Typography
          variant="pMd"
          bold
          className={classes.title}
          color="secondary"
        >
          Legacy Studio retires June 30, 2026
        </Typography>
        <Typography variant="pSm" color="primary">
          New Legacy projects won&apos;t be available after this date. Existing
          ones can be converted anytime.{' '}
          <TypographyLink
            href={learnMoreHref}
            target="_blank"
            rel="noopener noreferrer"
            variant="pSm"
            color="papaya_300"
            className={classes.learnMoreLink}
            underlined
          >
            Learn more
          </TypographyLink>
        </Typography>
      </Box>
    </Box>
  );
};

export default LegacyStudioRetirementNotice;
